export enum DisplayOptions {
  outputInput = 'output-input',
  inputOutput = 'input-output',
  output = 'output',
  input = 'input',
}
